import PropTypes from 'prop-types';
import React, { Component, memo } from 'react';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import ProtectionPlanLazy from 'yoda-site-components/lib/components/ProtectionPlan/ProtectionPlanLazy';
import CommonLazy from '../Common/CommonLazy';
import DeliveryOption from '../../../../components/DeliveryOption/DeliveryOption';

class Regular extends Component {
    static defaultProps = {
        query: {},
        featureFlags: {},
        location: {},
    };

    static propTypes = {
        isCollection: PropTypes.bool.isRequired,
        ppId: PropTypes.string.isRequired,
        query: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        location: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    };

    render() {
        const { isCollection, ppId, query, featureFlags, location, isBeauty } = this.props;

        return (
            <CommonLazy
                featureFlags={featureFlags}
                isCollection={isCollection}
                ppId={ppId}
                query={query}
                slot2={
                    <ErrorBoundary>
                        <DeliveryOption query={query} />
                    </ErrorBoundary>
                }
                slot4={
                    !featureFlags.disableProtectionPlan && (
                        <ErrorBoundary>
                            <ProtectionPlanLazy query={query} fromMiniPDP={false} />
                        </ErrorBoundary>
                    )
                }
                location={location}
                isBeauty={isBeauty}
            />
        );
    }
}

export default memo(Regular);
